"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAllMethodKeys = exports.getMethodKey = exports.setMethodKey = void 0;
var globals_1 = require("./globals");
/**
 * Associate a single method with a string (or function that returns a string) in our global method key store
 */
exports.setMethodKey = globals_1.globalMethodKeyCache.setMethodKey;
/**
 * Get the method key for a function from our global key store.  Generates a guid (and stores it for future use)
 * if the method key hasn't explicitly set via 'setMethodKey' or 'setAllMethodKeys'
 */
exports.getMethodKey = globals_1.globalMethodKeyCache.getMethodKey;
/**
 * Sets a method key for all of the methods in an object.  The keys include a provided prefix, and use the name of the
 * method property as the remaining portion of the key.
 *
 * @param prefix The prefix to use
 * @param obj The object to set keys for
 */
exports.setAllMethodKeys = function (prefix, obj) {
    Object.keys(obj).forEach(function (key) {
        if (typeof obj[key] === "function") {
            var method = obj[key];
            exports.setMethodKey(method, prefix + "." + key);
        }
    });
};
//# sourceMappingURL=functions.js.map